import { authClient, API } from '../index'

export const getBoxInvites = () => {
  return authClient().get(`${API}/box-invite`)
}

export const getBoxInvite = (id) => {
  return authClient().get(`${API}/box-invite/${id}`)
}

/** Alta de una caja nueva; el API genera la clave que irá a imprenta. */
export const createBoxInvite = (payload) => {
  return authClient().post(`${API}/box-invite`, payload)
}

/** Deja la caja como recién enviada (borra escaneos, respuestas y reserva). */
export const resetBoxInvite = (id) => {
  return authClient().post(`${API}/box-invite/${id}/reset`)
}

/** Notas, activación y personaje: los datos impresos en las cajas no se editan. */
export const updateBoxInvite = (id, payload) => {
  return authClient().put(`${API}/box-invite/${id}`, payload)
}
